import React from "react";

import { ScheduleDemoIcon, SupportIcon, WatchVideoIcon } from "../../../components";

const SCHEDULE_DEMO_URL = "https://coefficient.io/demo";

interface DashboardHelpMenuProps {
  visible: boolean;
  dropdownRef: React.RefObject<HTMLDivElement>;
  /** Whether to show the editor-only options (Schedule a demo, Watch how-to video). */
  showExtraOptions: boolean;
  onClose: () => void;
  onSupportFeedbackClick: () => void;
  onHelpVideoClick: () => void;
}

export const DashboardHelpMenu: React.FC<DashboardHelpMenuProps> = ({
  visible,
  dropdownRef,
  showExtraOptions,
  onClose,
  onSupportFeedbackClick,
  onHelpVideoClick,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="absolute right-full top-0 z-[210]">
      <div
        ref={dropdownRef}
        className="themed-dropdown-menu relative right-auto mt-0 w-max bottom-[6px] padding-[14px]"
        role="menu"
      >
        <button
          type="button"
          role="menuitem"
          className="themed-dropdown-item justify-start"
          onClick={() => {
            onClose();
            onSupportFeedbackClick();
          }}
        >
          <span className="w-5 flex-shrink-0 flex items-center justify-center">
            <SupportIcon fill="currentColor" />
          </span>
          <span className="mx-1 !text-[13px] font-medium">Support &amp; feedback</span>
        </button>
        {showExtraOptions && (
          <>
            <button
              type="button"
              role="menuitem"
              className="themed-dropdown-item justify-start"
              onClick={() => {
                onClose();
                window.open(SCHEDULE_DEMO_URL, "_blank", "noopener,noreferrer");
              }}
            >
              <span className="w-5 flex-shrink-0 flex items-center justify-center">
                <ScheduleDemoIcon fill="currentColor" />
              </span>
              <span className="mx-1 !text-[13px] font-medium">Schedule a demo</span>
            </button>
            <button
              type="button"
              role="menuitem"
              className="themed-dropdown-item justify-start"
              onClick={() => {
                onClose();
                onHelpVideoClick();
              }}
            >
              <span className="w-5 flex-shrink-0 flex items-center justify-center">
                <WatchVideoIcon fill="currentColor" className="shrink-0" />
              </span>
              <span className="mx-1 !text-[13px] font-medium">Watch how-to video</span>
            </button>
          </>
        )}
      </div>
    </div>
  );
};
